import { Component, NgZone, OnInit } from '@angular/core';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { LoaderService } from './core/service/loader.service';
import { messaging } from '../configs/firebase.config';
import { environment } from 'src/environments/environment';
import { NotificationPayload } from './shared/models/INotification';
import { LocalStorageService } from './core/service/local-storage.service';
import { ToastService } from './core/service/toast.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { OrderNotifyModalComponent } from './shared/components/order-notify-modal/order-notify-modal.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [DialogService],
})
export class AppComponent implements OnInit {
  loaderState: boolean;
  ref: DynamicDialogRef | undefined;

  constructor(
    private primengConfig: PrimeNGConfig,
    public loaderService: LoaderService,
    private toastService: ToastService,
    private zone: NgZone,
    private dialogService: DialogService,
  ) {}

  ngOnInit() {
    this.loaderService.getLoaderState().subscribe((state) => {
      this.loaderState = state;
    });
    this.primengConfig.ripple = true;
    this.listen();
  }

  listen() {
    messaging.onMessage((incomingMessage: NotificationPayload) => {
      console.log(incomingMessage);
      this.zone.run(() => {
        this.toastService.showSuccess(incomingMessage.notification.title, incomingMessage.notification.body);
        if (incomingMessage.data.type === 'order') {
          this.openOrderNotifyModal({ ...incomingMessage.notification, ...incomingMessage.data });
        }
        this.playAudio();
      });
    });
  }

  playAudio() {
    let audio = new Audio();
    audio.src = '../assets/ring_ring.mp3';
    audio.load();
    audio.play();
  }

  openOrderNotifyModal(order: any) {
    this.ref = this.dialogService.open(OrderNotifyModalComponent, {
      header: 'Order Created',
      width: '30vw',
      height: '50%',
      modal: true,

      data: {
        order: order,
      },
    });
    const subscription: Subscription = this.ref.onClose.subscribe((result: any) => {
      if (result && result === 'close') {
      }
      subscription.unsubscribe();
    });
  }
}
